<script>

    import moment from 'moment';

    export default {
        methods: {
            get_available_times(start, end, interval = null) {

                if (!interval) {
                    let user = null;
                    try {
                        user = this.$store.state.auth.user;
                    } catch (error) {
                        user = null;
                    }
    
                    if (user && user.calendar_interval > 0) {
                        interval = Math.min(5, user.calendar_interval);
                    }
                }

                var available_times = [];

                var start_time = moment(start, 'HH:mm');
                var end_time = moment(end, 'HH:mm');

                while (!start_time.isAfter(end_time)) {
                    available_times.push(start_time.format('HH:mm'));
                    start_time.add(interval, 'minutes');
                }

                return available_times;

            }
        }
    }

</script>